export function initSplitting() {
  const getAllSplits = document.querySelectorAll('[data-split]');

  //console.log('splitsies', getAllSplits);

  getAllSplits.forEach(splitContainer => {
    if ((<any>window).Splitting) {
      (<any>window).Splitting({ target: splitContainer, by: 'chars' });
    }
  });
}
